import { render, staticRenderFns } from "./news-details.vue?vue&type=template&id=52eb729a&"
import script from "./news-details.vue?vue&type=script&lang=js&"
export * from "./news-details.vue?vue&type=script&lang=js&"
import style0 from "./news-details.vue?vue&type=style&index=0&id=52eb729a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports